import { render } from "./WeightExcelImportHistory.vue?vue&type=template&id=6053fa2c"
import script from "./WeightExcelImportHistory.vue?vue&type=script&lang=js"
export * from "./WeightExcelImportHistory.vue?vue&type=script&lang=js"

import "./WeightExcelImportHistory.vue?vue&type=style&index=0&id=6053fa2c&lang=scss"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__